import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {DefautLayoutComponent} from './layouts';
import {LoginComponent} from './pages/login/login.component';
import {AuthGuardService} from './shares/services/auth-guard.service';
import {ReportTraceComponent} from './pages/report/report-trace/report-trace.component';
import {LayoutMapComponent} from './pages/map-info/layout-map/layout-map.component';
import {ReportProductCurdeComponent} from './pages/report/report-product-curde/report-product-curde.component';
import {ListSurveyComponent} from './pages/survey/list-survey/list-survey.component';
import {ListCategoryComponent} from './pages/survey/list-category/list-category.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'dashboard',
        pathMatch: 'full',
    },
    {
        path: 'info',
        component: LayoutMapComponent,
        pathMatch: 'full',
    },
    {
        path: 'login',
        component: LoginComponent,
        pathMatch: 'full',
    },
    {
        path: 'trace',
        component: ReportTraceComponent
    },
    {
        path: 'product-crude',
        component: ReportProductCurdeComponent
    },
    {
        path: '',
        component: DefautLayoutComponent,
        data: {
            breadcrumb: 'Home'
        },
        children: [
            {
                path: 'dashboard',
                loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardModule),
                data: {
                    breadcrumb: 'Dashboard'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'associations',
                loadChildren: () => import('./pages/company/company.module').then(m => m.CompanyModule),
                data: {
                    breadcrumb: 'Associations'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'users',
                loadChildren: () => import('./pages/users/users.module').then(m => m.UsersModule),
                data: {
                    breadcrumb: 'Users'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'suppliers',
                loadChildren: () => import('./pages/supplier/supplier.module').then(m => m.SupplierModule),
                data: {
                    breadcrumb: 'Supplier'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'agronomists',
                loadChildren: () => import('./pages/agronomist/agronomist.module').then(m => m.AgronomistModule),
                data: {
                    breadcrumb: 'Agronomist'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'fermenters',
                loadChildren: () => import('./pages/fermenter/fermenter.module').then(m => m.FermenterModule),
                data: {
                    breadcrumb: 'Fermenters'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'sources',
                loadChildren: () => import('./pages/sourcing/sourcing.module').then(m => m.SourcingModule),
                data: {
                    breadcrumb: 'Sources'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'farmers',
                loadChildren: () => import('./pages/farmer/farmer.module').then(m => m.FarmerModule),
                data: {
                    breadcrumb: 'Farmers'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'vendors',
                loadChildren: () => import('./pages/vendor/vendor.module').then(m => m.VendorModule),
                data: {
                    breadcrumb: 'Vendors'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'farmers-agronomist',
                loadChildren: () => import('./pages/farmer-agronomist/farmer-agronomist.module').then(m => m.FarmerAgronomistModule),
                data: {
                    breadcrumb: 'Farmers Agronomist'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'farmers-fermenter',
                loadChildren: () => import('./pages/farmer-agronomist/farmer-agronomist.module').then(m => m.FarmerAgronomistModule),
                data: {
                    breadcrumb: 'Farmers Fermenter'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'fermenter-sourcing',
                loadChildren: () => import('./pages/farmer-agronomist/farmer-agronomist.module').then(m => m.FarmerAgronomistModule),
                data: {
                    breadcrumb: 'Fermenter sourcing'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'notifications',
                loadChildren: () => import('./pages/notification/notification.module').then(m => m.NotificationModule),
                data: {
                    breadcrumb: 'Notifications'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'news',
                loadChildren: () => import('./pages/new/new.module').then(m => m.NewModule),
                data: {
                    breadcrumb: 'News'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'fertilizer-medicines',
                loadChildren: () => import('./pages/fertilizer-medicine/fertilizermedicine.module').then(m => m.FertilizerMedicineModule),
                data: {
                    breadcrumb: 'Fertilizer medicine'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'role-rights',
                loadChildren: () => import('./pages/role-right/role-right.module').then(m => m.RoleRightModule),
                data: {
                    breadcrumb: 'Role rights'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'farms',
                loadChildren: () => import('./pages/homenest/homenest.module').then(m => m.HomenestModule),
                data: {
                    breadcrumb: 'Farm'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'verifieds',
                loadChildren: () => import('./pages/verified/verified.module').then(m => m.VerifiedModule),
                data: {
                    breadcrumb: 'Verified home nest'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'reports',
                loadChildren: () => import('./pages/report/report.module').then(m => m.ReportModule),
                data: {
                    breadcrumb: 'Report'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'packages',
                loadChildren: () => import('./pages/package/package.module').then(m => m.PackageModule),
                // data: {
                //     breadcrumb: 'Report'
                // },
                canActivate: [AuthGuardService]
            },
            {
                path: 'process',
                loadChildren: () => import('./pages/process/process.module').then(m => m.ProcessModule),
                // data: {
                //     breadcrumb: 'Process'
                // },
                canActivate: [AuthGuardService]
            },
            {
                path: 'rating',
                loadChildren: () => import('./pages/rating/rating.module').then(m => m.RatingModule),
                // data: {
                //     breadcrumb: 'Đánh giá'
                // },
                canActivate: [AuthGuardService]
            },
            {
                path: 'cates',
                loadChildren: () => import('./pages/batch/batch.module').then(m => m.BatchModule),
                // data: {
                //     breadcrumb: 'Cates'
                // },
                canActivate: [AuthGuardService]
            },
            {
                path: 'scale',
                loadChildren: () => import('./pages/scale/scale.module').then(m => m.ScaleModule),
                // data: {
                //     breadcrumb: 'Cates'
                // },
                canActivate: [AuthGuardService]
            },
            {
                path: 'products',
                loadChildren: () => import('./pages/product/product.module').then(m => m.ProductModule),
                data: {
                    breadcrumb: 'Products'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'welcome',
                loadChildren: () => import('./pages/welcome/welcome.module').then(m => m.WelcomeModule),
                data: {
                    breadcrumb: 'Welcome'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'chat',
                loadChildren: () => import('./pages/chat-page/chat-page.module').then(m => m.ChatPageModule),
                data: {
                    breadcrumb: 'Chat'
                }
            },
            {
                path: 'events',
                loadChildren: () => import('./pages/event/event.module').then(m => m.EventModule),
                data: {
                    breadcrumb: 'Event'
                }
            },
            {
                path: 'farm-season',
                loadChildren: () => import('./pages/farm-season/farm-season.module').then(m => m.FarmSeasonModule),
                // data: {
                //     breadcrumb: 'Farm season'
                // },
                canActivate: [AuthGuardService]
            },
            {
                path: 'problem',
                loadChildren: () => import('./pages/problem/problem.module').then(m => m.ProblemModule),
                data: {
                    breadcrumb: 'Problem'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'contracts',
                loadChildren: () => import('./pages/contract/contract.module').then(m => m.ContractModule),
                data: {
                    breadcrumb: 'Contract'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'report-material',
                loadChildren: () => import('./pages/report-material/report-material.module').then(m => m.ReportMaterialModule),
                data: {
                    // breadcrumb: 'Contract'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'report-fermentation',
                loadChildren: () => import('./pages/report-fermentation/report-fermentation.module').then(m => m.ReportFermentationModule),
                data: {
                    // breadcrumb: 'Contract'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'report-farm',
                loadChildren: () => import('./pages/report-farm/report-farm.module').then(m => m.ReportFarmModule),
                data: {},
                canActivate: [AuthGuardService]
            },
            {
                path: 'report-farmer',
                loadChildren: () => import('./pages/report-farmer/report-farmer.module').then(m => m.ReportFarmerModule),
                data: {},
                canActivate: [AuthGuardService]
            },
            {
                path: 'report-contract',
                loadChildren: () => import('./pages/report-contract/report-contract.module').then(m => m.ReportContractModule),
                data: {
                    breadcrumb: 'Contract'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'report-trace-contract',
                loadChildren: () => import('./pages/report-trace-contract/report-trace-contract.module')
                                    .then(m => m.ReportTraceContractModule),
                data: {
                    breadcrumb: 'Contract'
                },
                canActivate: [AuthGuardService]
            },
            {
                path: 'survey',
                loadChildren: () => import('./pages/survey/survey.module').then(m => m.SurveyModule),
                data: {
                    breadcrumb: 'Khảo sát'
                },
                canActivate: [AuthGuardService],
            },
            {
                path: 'surveyResultAndAnalysis',
                loadChildren: () => import('./pages/surveyResult/survey-result.module').then(m => m.SurveyResultModule),
                data: {
                    breadcrumb: 'Kết quả và phần tích'
                },
                canActivate: [AuthGuardService],
            },
            {
                path: 'plan',
                loadChildren: () => import('./pages/plan/plan.module').then(m => m.PlanModule),
                data: {
                    breadcrumb: 'Kế hoạch'
                },
                canActivate: [AuthGuardService],
            },
        ]
    }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
